import './Logos.scss';
import { $, SlickSlider } from "../../../common/scripts/Libs";

class Logos {

  constructor(node) {
    this.node = node;
  }

  init() {
    const logos = $(this.node).find('.logos')
    const noSlider = $(logos).hasClass('no-slider')

    if (logos.length <= 0 && noSlider) return

    logos.slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 1400,
      variableWidth: false,
      mobileFirst: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 6,
          }
        }
      ]
    }, SlickSlider);
  }

}

JSModules['Logos'] = Logos;
export default Logos;
